import { Skeleton, styled } from '@mui/material';

export const MuiSkeleton = styled(Skeleton)({
  borderRadius: 'var(--border-radius-big)',
  flexShrink: 0,
  height: '16rem',
});
